import { _t } from "../../languageHandler";

// These are in their own file because of circular imports being a problem.
export enum RightPanelPhases {
    // Room & Space stuff
    MemberList = "MemberList",
    MemberInfo = "MemberInfo",
    // ThreePidMemberInfo = "ThreePidMemberInfo",

    // Room stuff
    FilePanel = "FilePanel",
    NotificationPanel = "NotificationPanel",
    EncryptionPanel = "EncryptionPanel",
    RoomSummary = "RoomSummary",
    // Widget = "Widget",
    PinnedMessages = "PinnedMessages",
    Timeline = "Timeline",
    // Extensions = "Extensions",

    // Thread stuff
    // ThreadView = "ThreadView",
    // ThreadPanel = "ThreadPanel",

    // HomePage/Call stuff
    CallParticipants = "CallParticipants",
}

export function backLabelForPhase(phase: RightPanelPhases | null): string | null {
    switch (phase) {
        // case RightPanelPhases.ThreadPanel:
        //     return _t("common.threads");
        case RightPanelPhases.Timeline:
            return _t("chat_card_back_action_label");
        case RightPanelPhases.RoomSummary:
            return _t("room_summary_card_back_action_label");
        case RightPanelPhases.MemberList:
            return _t("member_list_back_action_label");
        case RightPanelPhases.CallParticipants:
            return _t("common.participants");
        // case RightPanelPhases.ThreadView:
        //     return _t("thread_view_back_action_label");
    }
    return null;
}
